function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#1E72D7",
  clipPath: "url(#clip0_11039_527647)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.13 25C19.53 25 15 20.42 15 14.82A10.17 10.17 0 0125.19 4.69 10.17 10.17 0 0135.3 14.85c0 5.6-4.57 10.16-10.17 10.15zm.02-1.56a8.6 8.6 0 008.6-8.6 8.6 8.6 0 10-8.6 8.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.37 13.28v-2.96c0-.57.3-.93.77-.94.48 0 .8.36.8.95v5.92c0 .57-.3.93-.77.94-.49 0-.8-.36-.8-.95v-2.96zM25.19 18.75c.41.02.75.38.74.8 0 .43-.38.78-.8.76a.79.79 0 01-.75-.83c.02-.41.39-.74.8-.73z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.97 28.5a14.8 14.8 0 008.65-17.03 13.7 13.7 0 00-3.93-7.07A14.94 14.94 0 0025.15 0a14.76 14.76 0 00-12.22 6.43l-.1.16-.03.04a14.76 14.76 0 00-2.5 8.22v.08l.01.19v.16c.05 1.79.42 3.58 1.15 5.3l.02.05a26.65 26.65 0 00.25.54 14.88 14.88 0 002.32 3.52l-1.8 1.8c-.24-.25-.51-.55-.8-.84-.59-.6-.92-.6-1.5-.01-2.83 2.82-5.63 5.64-8.46 8.44A4.62 4.62 0 000 36.4v.94l.06.1a3.01 3.01 0 002.26 2.44c1.22.34 2.27-.05 3.16-.94l8.92-8.92c.52-.52.53-.9.02-1.4-.32-.32-.65-.62-.92-.87l1.8-1.8.04.02a14.87 14.87 0 009.81 3.72c1.97 0 3.84-.38 5.56-1.08l.13-.05.12-.05zm-18.25 1l-8.4 8.38c-.45.46-.98.67-1.62.49a1.55 1.55 0 01-.81-2.44c.07-.1.15-.18.23-.26l8.42-8.42.1-.1 2.2 2.2-.12.14zm25.61-14.65a13.2 13.2 0 01-13.18 13.17 13.2 13.2 0 01-13.17-13.17A13.2 13.2 0 0125.15 1.67a13.2 13.2 0 0113.18 13.18z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_11039_527647"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})));

function SvgInfoOrg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOrg);
export default __webpack_public_path__ + "static/media/info-org.45eaf929.svg";
export { ForwardRef as ReactComponent };